export enum InteractionType {
  PRIMARY,
  SECONDARY,
  LINKED,
}

export enum InteractionStatus {
  OPENED,
  CLOSED,
  IN_APPROVAL,
}

export interface IInteractionContactContent {
  content: string;
  interactionType: string;
  media: string;
  parentUuid: string;
}
